import { createSlice } from "@reduxjs/toolkit";

const normalizeMediaUrl = (value) =>
  value && String(value).trim() ? String(value).trim() : null;

const initialState = {
  theme: "light",
  colors: {
    primary: "#E91E8C",
    text: "#262525",
    primary_text_color: "#1A1A1A",
    secondary_text_color: "#6B6B6B",
    chip_background_color: "#F3E5F5",
    back_arrow_color: "#7B1FA2",
    primary_gradient_start_color: "#FF2D95",
    primary_gradient_end_color: "#7B1FA2",
    borderColor: "#E1BEE7",
    background: "#ffffff",
    link_color: "#C2185B",
    tab_bar_active: "#E91E8C",
    tab_bar_inactive: "#CE93D8",
    screen_background: "#FBF7FC",
    main_icon: "#E91E8C",
    normal_icon: "#7B1FA2",
  },
  fontSize: {
    large: 18,
    medium: 16,
    small: 14,
  },
  logourl: {
    dark_logo: null,
    light_logo: null,
    banner_image: null,
    favicon: null,
  },
  contact: {
    email: null,
    phone: null,
    address: null,
    workingHours: null,
  },
  social: {
    facebook: null,
    instagram: null,
    twitter: null,
    linkedin: null,
  },
};

const themeValueSlice = createSlice({
  name: "themeValue",
  initialState,
  reducers: {
    setTheme(state, action) {
      state.theme = action.payload;
    },

    setThemeData(state, action) {
      const d = action.payload || {};

      state.colors = {
        primary: d.primary_color,
        text: d.text,
        primary_text_color: d.primary_text_color,
        secondary_text_color: d.secondary_text_color,
        primary_gradient_start_color: d.primary_gradient_start_color,
        primary_gradient_end_color: d.primary_gradient_end_color,
        chip_background_color: d.chip_background_color,
        back_arrow_color: d.back_arrow_color,
        borderColor: d.borderColor,
        background: d.background,
        link_color: d.link_color,
        tab_bar_active: d.tab_bar_active,
        tab_bar_inactive: d.tab_bar_inactive,
        screen_background: d.screen_background,
        main_icon: d.main_icon,
        normal_icon: d.normal_icon,
      };

      state.fontSize = {
        large: d.fontsize_large,
        medium: d.fontsize_medium,
        small: d.fontsize_small,
      };

      state.logourl = {
        dark_logo: normalizeMediaUrl(d.dark_logo),
        light_logo: normalizeMediaUrl(d.light_logo),
        banner_image: normalizeMediaUrl(d.banner_image),
        favicon: normalizeMediaUrl(d.favicon),
      };

      state.contact = {
        email: d.contact_email ?? null,
        phone: d.contact_phone ?? null,
        address: d.contact_address ?? null,
        workingHours: d.working_hours ?? null,
      };

      // Support nested social object or flat fields from API
      state.social = {
        facebook: d.social?.facebook ?? d.facebook ?? null,
        instagram: d.social?.instagram ?? d.instagram ?? null,
        twitter: d.social?.twitter ?? d.twitter ?? null,
        linkedin: d.social?.linkedin ?? d.linkedin ?? null,
      };
    },

    changeThemeColor(state, action) {
      state.theme = action.payload;
    },
  },
});

export const { setTheme, setThemeData, changeThemeColor } = themeValueSlice.actions;
export default themeValueSlice.reducer;
